import { render, staticRenderFns } from "./ServiceUpdate.vue?vue&type=template&id=3cb0af8c&scoped=true"
import script from "./ServiceUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceUpdate.vue?vue&type=script&lang=js"
import style0 from "./ServiceUpdate.vue?vue&type=style&index=0&id=3cb0af8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0af8c",
  null
  
)

export default component.exports